import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceIstvanMiklos.png";
import face_image_2 from "../../assets/img/faceBalazsHeilig.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projMiklosI_HeiligB_ionosphere.png";

const I_Miklos_and_B_Heilig_ionosphere = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">István Miklós{" "}</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">Balázs Heilig{" "}</p>
            <br />
            <p className="text8">
              Deputy Director General{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Rényi Institute, HUN-REN </p>
            </div>
            <div>
            <p className="text8">HUN-REN EPSS </p>
            </div>
            <div>
            The ionosphere–plasmasphere system strongly influences radio wave propagation and satellite navigation (e.g. GPS). 
            Variations in electron density cause signal delays and positioning errors, making accurate three-dimensional modelling 
            essential. While ionospheric tomography is well studied, the plasmaspheric contribution is often neglected, despite the 
            fact that it can account for a significant fraction of the total electron content under certain conditions.
            <br/>
            <br/>
            The aim of this project is to develop mathematical and computational methods for 3D ionosphere–plasmasphere tomography, 
            explicitly incorporating plasmaspheric effects into reconstruction models. The focus is on reconstructing electron 
            density from GNSS-based Total Electron Content (TEC) measurements, possibly complemented by data from low-Earth-orbit 
            satellites (e.g. ESA’s Swarm mission).
            <br/>
            <br/>
            Depending on the student’s interests, the project may include:
            <ul>
                <li>
                    processing GNSS TEC data from ground-based receiver networks,
                </li>
                <li>
                    formulating the reconstruction as a 3D inverse problem,
                </li>
                <li>
                    developing voxel-based tomographic methods,
                </li>
                <li>
                    applying regularization or Bayesian approaches,
                </li>
                <li>
                    integrating multiple data sources and assessing reconstruction uncertainty.
                </li>
            </ul>
            <br/>
            The student will gain experience with real geophysical data, inverse problems, and large-scale numerical methods, while contributing to improved modelling of the ionosphere–plasmasphere system.
            <br/>
            <i>Recommended for MSc students in applied mathematics, engineering mathematics, or related fields. Collaboration with researchers from the HUN-REN research network is expected.</i>



            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default I_Miklos_and_B_Heilig_ionosphere;